import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  consents: {},
  result: {},
  processId: null,
  contractDocumentUrl: null,
  confirmStatus: '',
  backendErrorCode: null,
  backendErrorMessage: null
}

const CheckoutSubmitModule = {
  namespaced: true,
  state: initialState,
  getters: {
    deferredResponse: (state) => {
      return state.result?.deferredIdentificationResponse
    },
    getSuccessUrl: (state, getters) => {
      return getters.deferredResponse?.url || null
    },
    consents: (state) => {
      return state.consents
    },
    processId: (state) => {
      return state.processId
    },
    contractId: (state) => {
      return state.result?.contractId
    },
    contractDocumentUrl: (state) => {
      return state.contractDocumentUrl
    },
    checkoutInputCore: (state, getters, rootState, rootGetters) => {
      const inputCore = {
        customer: {
          address: rootGetters['checkout/personalData/address'],
          ...rootGetters['checkout/personalData/person'],
          email: rootGetters['checkout/personalData/email'],
          contactNumber: rootGetters['checkout/personalData/contactNumberFormatted']
        },
        brand: rootGetters.brand,
        payment: rootGetters['checkout/paymentData/payment']
      }
      if (rootGetters['checkout/personalData/additional'].simType === 'E_SIM') {
        inputCore.deferredIdentification = rootGetters['checkout/ident/identificationCore']
      }
      return inputCore
    },
    checkoutPortabilityCore: (state, getters, rootState, rootGetters) => {
      if (rootGetters['checkout/mnpData/active'] && rootGetters['checkout/mnpData/providerCode'] && rootGetters['checkout/mnpData/providerKey'] && !rootGetters['checkout/mnpData/unportable']) {
        return {
          mobileNumberPortability: {
            ...rootGetters['checkout/personalData/portability'],
            ...rootGetters['checkout/mnpData/portabilityCore']
          }
        }
      } else {
        return {}
      }
    },
    getSuccessIdent: (state, getters, rootState, rootGetters) => {
      if (getters.deferredResponse?.identProvider === 'Deutsche_Post') {
        if (rootGetters['activation/personalData/identificationCore'].identMethod === 'video') {
          return 'videoIdentPost'
        }
        if (rootGetters['activation/personalData/identificationCore'].identMethod === 'store') {
          return 'postIdent'
        }
      }
      if (getters.deferredResponse?.identProvider === 'WebId') {
        return 'videoIdentWeb'
      }
      return null
    }
  },
  mutations: {
    storeResult: (state, result) => {
      state.result = result
    },
    storeProcessId: (state, processId) => {
      state.processId = processId
    },
    storeConsents: (state, consents) => {
      state.consents = consents
    },
    storeContractDocumentUrl: (state, contractDocumentUrl) => {
      state.contractDocumentUrl = contractDocumentUrl
    },
    confirmStatus: state => state.validationStatus,
    backendErrorCode: state => state.backendErrorCode,
    backendErrorMessage: state => state.backendErrorMessage
  },
  actions: {
    async checkoutInitiate ({ commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation activation ($activationInput: ActivationInput!) {
            activationInitiate (activationInput: $activationInput){
              contractDocumentUrl
              processId
            }
          }`,
        variables: {
          activationInput: {
            ...getters.checkoutInputCore,
            ...getters.checkoutPortabilityCore,
            product: {
              tariffIdentifier: rootGetters['checkout/info/tariffIdentifier'],
              promotions: null,
              tariffoptions: null,
              article: null
            },
            orderContext: {
              market: rootGetters['activation/info/market']
            }
          }
        }
      }).then((response) => {
        commit('storeProcessId', response.data.checkoutInitiate.processId)
        commit('storeContractDocumentUrl', response.data.checkoutInitiate.contractDocumentUrl)
        return response.data.checkoutInitiate.contractDocumentUrl
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async checkoutConfirm ({ commit, state, getters, rootGetters }, { nextStep = 'success', consents }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation checkout ($orderConfirmInput: OrderConfirmInput!) {
            orderConfirm (orderConfirm: $orderConfirmInput){
              contractId,
              customerId,
              deferredIdentificationResponse {
                actionID,
                identProvider,
                url
              }
            }
          }`,
        variables: {
          orderConfirmInput: {
            brand: rootGetters.brand,
            processId: getters.processId,
            channel: 'BRANDED_PORTAL',
            orderConsent: {
              adConsent: true,
              passData: true,
              agb: true,
              contractTermsVersion: '1.0'
            }
          }
        }
      }).then((response) => {
        commit('storeConsents', consents)
        commit('storeResult', response.data.orderConfirm)
        commit('Transaction/removeTransactionId', 'activation', { root: true })
        commit('activation/goToStep', nextStep, { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  }
}

export {
  CheckoutSubmitModule
}
